import React from 'react';
import { Alert, IconButton, Stack } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import ValidationError from './ValidationError';
import ValidationErrorDetails from './ValidationErrorDetails';
import DefaultErrorDetails from './DefaultErrorDetails';

const ErrorView = ({ error, onClose }) => {
    if (!error) {
        return null;
    }
    return (
        <Stack spacing={2} mb={2} p={1}>
            <Alert
                severity="error"
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={onClose}
                    >
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                }
            >
                {error instanceof ValidationError ? (
                    <ValidationErrorDetails error={error} />
                ) : (
                    <DefaultErrorDetails error={error} />
                )}
            </Alert>
        </Stack>
    );
};

export default ErrorView;
